import { put, putMany, setMeta } from "./db";

/** Request path with the /api prefix and query string stripped. */
export const pathOf = (config) => {
  let url = config?.url || "";
  if (/^https?:\/\//i.test(url)) {
    try {
      url = new URL(url).pathname;
    } catch {
      /* keep as is */
    }
  }
  url = url.split("?")[0].replace(/^\/api/, "");
  url = url.replace(/\/+$/, "");
  return url || "/";
};

export const keyOf = (config) => {
  const params = { ...(config?.params || {}) };
  delete params.workspace_id;
  const qs = Object.keys(params)
    .sort()
    .filter((k) => params[k] !== undefined && params[k] !== null && params[k] !== "")
    .map((k) => `${k}=${params[k]}`)
    .join("&");
  const path = pathOf(config);
  return qs ? `${path}?${qs}` : path;
};

const isDiary = (path) => /^\/matters\/[^/]+\/diary$/.test(path);

/** Copies a successful GET into IndexedDB — entity stores plus a raw response cache. */
export const mirror = async (config, data) => {
  if (data === undefined || data === null) return;
  const path = pathOf(config);
  const params = config?.params || {};
  try {
    await put("kv", { data, at: new Date().toISOString() }, keyOf(config));

    if (Array.isArray(data)) {
      if (path === "/events") await putMany("events", data);
      else if (path === "/matters") await putMany("matters", data);
      else if (path === "/courts") await putMany("courts", data);
      else if (path === "/todos") await putMany("todos", data);
      else if (path === "/logs") await putMany("logs", data);
      else if (path === "/postits") {
        await putMany("postits", data);
        if (!params.matter_id && !params.event_id && !params.todo_id) {
          await setMeta("postit_order", data.map((n) => n.post_it_id));
        }
      }
      return;
    }

    if (path === "/events/uncategorized") {
      await putMany("events", [...(data.upcoming || []), ...(data.past || [])]);
    } else if (path === "/dashboard/summary") {
      await putMany("events", [...(data.today_events || []), ...(data.next_up || [])]);
    } else if (isDiary(path)) {
      await putMany("matters", [data.matter]);
      await putMany("logs", data.logs || []);
      await putMany("events", [...(data.upcoming || []), ...(data.past || [])]);
    } else if (path === "/overview" && Array.isArray(data.days)) {
      await putMany("events", data.days.flatMap((d) => d.events || []));
    } else if ((path === "/kit/range" || path === "/kit/day") && Array.isArray(data.kits)) {
      await putMany("kits", data.kits);
    } else if (/^\/kit\/[^/]+$/.test(path) && data.event_id) {
      await putMany("kits", [data]);
    }
  } catch {
    /* the mirror is best effort — never break a live request */
  }
};
